import { RepeatIcon } from "@chakra-ui/icons";
import { Td, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function TdActions() {
  return (
    <Td aria-label="Actions" w="36px" textAlign="center">
      <Menu>
        <MenuButton aria-label="Options" w="16px">
          <FontAwesomeIcon icon={["far", "ellipsis-vertical"]} />
        </MenuButton>
        <MenuList>
          <MenuItem icon={<RepeatIcon />}>Sample</MenuItem>
        </MenuList>
      </Menu>
    </Td>
  );
}
